const state = {
    suppliers: [],
    supplierId: [],
    loading: false
};

export default state;